<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
 data() {
  return {
   errors: {}, 
   toast: useToast(),
   id: '',
   name: '' 
  };
 },
 methods: {
  
  industry(row = null){
   this.resetForm(); 
   if(row != null){
    this.id = row.id;
    this.name = row.name;
   } 
  },  

   async saveIndustry(){
    this.errors = {};
    this.setLoading(true); 
    try{
     const payload = {
      id: this.id,
      name: this.name  
     };   
     let response = [];
     if(this.id){
      response = await axios.put('/industries/update', payload);
     }else{
      response = await axios.post('/industries/create', payload);
     }
     this.toast.success(response.data.message);
     this.$emit('updated'); 
     this.closeModal('industry_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.toast.error(error.message);
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteIndustry(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/industries/${this.id}/delete`);
    this.toast.success(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.toast.error(error.message);
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
 <div class="modal fade" id="industry_modal">
 <div class="modal-dialog modal-dialog-centered modal-mg w-100">
 <div class="modal-content">
 <div class="modal-header">
  <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Industry</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
  </button>
 </div>
 <form @submit.prevent="saveIndustry">
  <div class="modal-body pb-0">
   <div class="row">
    <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Name</label>
     <input type="text" class="form-control" v-model="name" />
     <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
    </div>
    </div>
        
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Save</button>
    </div>
  </form>
 </div>
</div>
</div>
  <!-- /Add -->

<!-- Delete Modal -->
<div class="modal fade" id="delete_modal">
 <div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
   <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
     <i class="ti ti-trash-x fs-36"></i>
    </span>
     <h4 class="mb-1">Confirm Delete</h4>
     <p class="mb-3"> You want to delete the item, this cant be undone once you delete.</p>
     <div class="d-flex justify-content-center">
     <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
     <a href="javascript:void(0);" class="btn btn-danger" @click="deleteIndustry">Yes, Delete</a>
     </div>
   </div>
  </div>
 </div>
</div>
<!-- /Delete Modal -->
</template>